import { Component, Fragment } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Fab, Loader, Tooltip, Login } from '../cdl-react-components/components'
import Header from './Header'
import Controls from './Controls'
import MainSidebar from './Sidebar/MainSidebar'
import SubSidebar from './Sidebar/SubSidebar'
import Main from './Main'
import Offline from './Offline'
import Notifications from '../Utilities/Notifications'
import Search from '../Utilities/Search'
import Results from '../Utilities/Results'
import CookieConsent from '../Utilities/Notifications/CookieConsent'
import UnsupportedBrowser from '../Utilities/Notifications/UnsupportedBrowser'
import UrlParametersSync from '../Utilities/UrlParameterSync'
import { CONTENT_MODE } from '../../utilities/constants'
import Pages from '../Pages'
import { setUser, updateShowTooltip, setConfiguration, setConfigurationLoginModalOpen } from '../../store/actions'
import { getCookie, setCookie, parseUrlParams } from '../cdl-react-components/utilities'
import RSVPPopup from '../Utilities/RSVPPopup'
import Analytics from '../Utilities/Analytics'
import MobileLogger from '../Utilities/MobileLogger'
//import { authenticated } from '../cdl-react-components/utilities'

class Layout extends Component {
    state = {}

    cookieName = 'ShowDigestTutorialCookie'

    /* IMPORTANT!!!!!!
     * These touch callbacks store values on the window object.
     * We do this because of an issue with the JsxParser in the RenderedPage 
     * component.
     * If we cause a update to this component with a touch event it causes
     * the JsxParser to re-mount itself, and more importantly all of it's children.
     * This means that if we're trying to fill out a form generated in the RenderedPage
     * every touch will remount the form, meaning none of our inputs values persist.
     * 
     * tldr: updates from touch events cause issues deeper in the app - rrogers 2019-01-14 */
    handleTouchStart = (e) => window.initialPosX = e.targetTouches[0].clientX
    handleTouchMove = (e) => window.finalPosX = e.targetTouches[0].clientX
    handleTouchEnd = (e) => {
        const { initialPosX, finalPosX } = window
        let callback = undefined

        if (initialPosX && finalPosX) {
            if (initialPosX > finalPosX && initialPosX - finalPosX > 200)
                callback = this.handleSwipeLeft
            else if (finalPosX > initialPosX  && finalPosX - initialPosX > 200) 
                callback = this.handleSwipeRight
        }

        window.initialPosX = undefined
        window.finalPosX = undefined 
        callback && callback()
    }

    handleSwipeRight = () => {
        // only show sidebar if subsidebar is already shown
        const sidebarShown = this.props.configuration.subSidebarShown
        this.props.setConfiguration({
            sidebarShown,
            subSidebarShown: true
        })
    }

    handleSwipeLeft = () => {
        // only hide subsidebar if sidebar is already shown
        const subSidebarShown = this.props.configuration.sidebarShown 
        this.props.setConfiguration({
            sidebarShown: false,
            subSidebarShown
        })
    }

    openSidebar = () => 
        this.props.setConfiguration({
            sidebarShown: true,
            subSidebarShown: true
        })
    closeSidebar = () => 
        this.props.setConfiguration({
            sidebarShown: false,
            subSidebarShown: false
        })
    openSubSidebar = () => {
        this.props.setConfiguration({
            sidebarShown: false,
            subSidebarShown: true
        })
    }
    toggleSidebar = () => {
        this.props.configuration.sidebarShown || this.props.configuration.subSidebarShown ?
            this.closeSidebar() :
            this.openSidebar()
        setCookie(this.cookieName, true)
    }

    closeLogin = () => this.props.setConfigurationLoginModalOpen(false)

    render() {
        const online = navigator.onLine
        return (
            <BrowserRouter>
                <Analytics />
                <MobileLogger />
                <div id="layout">
                    <div id="layout__header">
                        <Header />
                    </div>
                    { online ?
                        (<div id="layout__body"
                            className={this.props.user ? 'layout__body--authed' : ''}
                            onTouchStart={this.handleTouchStart}
                            onTouchMove={this.handleTouchMove}
                            onTouchEnd={this.handleTouchEnd}>
                            <Controls cookieName={this.cookieName}/>
                            <MainSidebar shown={this.props.configuration.sidebarShown}>
                                <Search onComplete={this.openSubSidebar} />
                            </MainSidebar>
                            <SubSidebar shown={this.props.configuration.subSidebarShown}>
                                <Results onComplete={this.closeSidebar} />
                            </SubSidebar>
                            <Main>
                                { this.props.showLoader ? <Loader /> : null }
                                <Pages />
                            </Main>
                            <RSVPPopup />
                        </div>) :
                        (<Offline />)}
                    { !this.props.user ? (
                        <Login 
                            open={this.props.loginModalOpen || false}
                            onClose={this.closeLogin} 
                            setUser={this.props.setUser} />) : null }
                    { online ?
                        (<Fragment>
                            <UrlParametersSync />
                            <Tooltip parent="#header__search-icon" className="hide-phone hide-tablet" show={this.props.showTooltip}>Search for Content</Tooltip>
                            <Notifications />
                            <CookieConsent />
                            <UnsupportedBrowser />
                            <Fab id="layout__fab"
                                className="hide-desktop"
                                onClick={this.toggleSidebar}>
                                search
                            </Fab>
                        </Fragment>
                        ) : null }
                </div>
            </BrowserRouter>
        )
    }

    componentDidMount() {
        // on inital app load try to grab the user from OPSP
        this.props.setUser()
        setTimeout(() => {
            if (!getCookie(this.cookieName))
                this.props.updateShowTooltip(true)
        }, 3000)

        setInterval(this.props.setUser, 30000)
    }

    componentDidUpdate() {
        const { contentMode } = this.props.configuration
        if (typeof contentMode !== 'undefined' && !this.state.defaultOpenConfigSet) {
            if (contentMode === CONTENT_MODE.DESKTOP) {
                const urlParams = parseUrlParams()
                this.props.setConfiguration({
                    sidebarShown: !!urlParams.search,
                    subSidebarShown: !!urlParams.results
                })
            }

            this.setState({ defaultOpenConfigSet: true })
        }
    }
}

const mapStateToProps = ({data}) => ({
    configuration: data.configuration,
    loginModalOpen: data.configuration.loginModalOpen,
    user: data.user,
    showTooltip: data.showTooltip,
    showLoader: (data.configuration && data.configuration.showLoader) || false
})

const mapDispatchToProps = (dispatch) => ({
    setUser: () => dispatch(setUser()),
    setConfiguration: (configuration) => dispatch(setConfiguration(configuration)),
    setConfigurationLoginModalOpen: (open) =>  dispatch(setConfigurationLoginModalOpen(open)),
    updateShowTooltip: showTooltip => dispatch(updateShowTooltip(showTooltip))
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout)